import React from "react";
import { Label, Input } from "@revvsales/components";

export default function PricingMethodOptions(props) {
  const { type, pricingMethodData, pricingMethodLabels } = props;
  return (
    <Label
      className="pricing-individual-radio"
      htmlFor={`${type.alias}-type`}
      key={type.alias}>
      <Input
        className="pricing-radio-button"
        id={`${type.alias}-type`}
        type="radio"
        value={type.label}
        checked={pricingMethodData.view === type.label}
        name={type.alias}
        readOnly
      />
      <div className="pricingmethodwrapper-title-wrapper">
        <span className="pricingmethodwrapper-title">
          {pricingMethodLabels[type.label]}
        </span>
        <span className="pricingmethodwrapper-description" />
      </div>
    </Label>
  );
}



// WEBPACK FOOTER //
// ./src/components/Pricebook/PricingMethodWrapper/PricingMethodOptions/PricingMethodOptions.js